export default "__VITE_ASSET__BtW78OnE__"